"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.readyEvent = void 0;
const utils_1 = require("../utils");
const readyEvent = ({ trackingService, componentNameWithSpaces, componentNameWithDashes, defaultComponentAdditions, }) => (customEvent = {}) => {
    if (!trackingService) {
        return;
    }
    const defaultReadyEvent = {
        event: {
            attributes: {
                componentName: componentNameWithDashes,
                elementName: '',
                label: '',
                clickID: '',
                pos: '',
                targetURL: '',
                value: '',
            },
            eventInfo: {
                eventAction: 'feature_app_ready',
                eventName: `${componentNameWithSpaces} - Feature App ready`,
            },
        },
        componentUpdate: defaultComponentAdditions,
    };
    const mergedEvent = (0, utils_1.mergeHandler)(defaultReadyEvent, customEvent, {
        merge: 'deep',
        arrayBehavior: 'replace',
    });
    trackingService.track(mergedEvent);
};
exports.readyEvent = readyEvent;
//# sourceMappingURL=send-ready.js.map